import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import About from "./About";
import JoinUs from "./JoinUs";

export default function Landing({ dashClicked }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1;
    }
  }, []);

  const [about, setAbout] = useState(false);
  const [joinUs, setJoinUs] = useState(false);

  return (
    <>
      <video
        ref={videoRef}
        src={`${process.env.PUBLIC_URL}/background.mp4`}
        muted
        autoPlay
        playsInline
        loop
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          objectFit: "cover",
          zIndex: -1,
          opacity: 0.85,
        }}
      />

      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Logo"
        style={{ position: "fixed", top: 16, left: 16, width: 120 }}
      />

      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <About showAbout={about} onClose={() => setAbout(false)} />
        <JoinUs showJoin={joinUs} onClose={() => setJoinUs(false)} />
        <h1 style={{
          color: "white",
          fontSize: "2.2rem",
          fontWeight: 700,
          marginBottom: 24,
          textShadow: "0 2px 8px rgba(0,0,0,0.4)",
        }}>
          UBC Trading Group
        </h1>
        <div>
          <Button style={{ margin: 7, width: 150 }} variant="dark" onClick={() => setAbout(true)}>About Us</Button>
          <Button style={{ margin: 7, width: 150 }} variant="dark" onClick={() => setJoinUs(true)}>Join our Team</Button>
          <Button style={{ margin: 7, width: 150 }} variant="dark" onClick={() => dashClicked(true)}>Backtest Engine</Button>
        </div>
      </div>
    </>
  );
}
